<template>
  <x-page title="确认订单" :loading="loading">
    <template v-if="!loading">
      <!-- 商品列表 -->
      <x-card :class="_.merchant">
        <div :class="[_.hd, _._hairlineBottom]">
          <img :src="require('./images/店铺.png')" :class="_.logo" />
          <div :class="_.name">{{ goodsData.merchantName }}</div>
        </div>
        <div :class="_.bd">
          <div :class="_.goods">
            <van-image :src="goodsData.coverPic" :class="_.cover" fit="cover" />
            <div :class="_.main">
              <div :class="_.top">
                <div :class="_.content">
                  <div :class="[_.name, _._ellipsis2]">
                    {{ goodsData.commodityTitle }}
                  </div>
                </div>
                <div :class="_.info">
                  <div :class="_.price">￥{{ goodsData.price }}</div>
                  <div :class="_.amount">x1</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div :class="_.ex">
          <div :class="_.count">共 1 件</div>
          <div :class="_.label">小计</div>
          <div :class="_.unit">¥</div>
          <div :class="_.price">
            {{ goodsData.price }}
          </div>
        </div>
      </x-card>

      <!-- 概况 -->
      <x-card :class="_.brief">
        <div :class="_.item">
          <div :class="_.label">商品总额</div>
          <div :class="_.value">¥{{ goodsData.price }}</div>
        </div>
      </x-card>

      <!-- 操作 -->
      <div :class="_.actions">
        <div :class="_.ft">
          <div :class="_.amount">共1件,</div>
          <div :class="_.total">合计:￥{{ goodsData.price }}</div>
          <div :class="_.grow" />

          <div
            v-track="{
              name: '确认订单-立即支付',
              id: '334a0312-e334-4ab4-8bf9-51ca1c0138e1',
              content: goodsData.commodityId,
            }"
            :class="_.button"
            @click="handlePayClick"
          >
            立即支付
          </div>
        </div>
      </div>
      <div :class="_.placeholder" />
    </template>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import {
    apiShopOpenV1OpenTradeGoodsDetail,
    apiShopOpenV1OpenTradeOrderTradeOrder,
  } from '@/api'
  import { dcb } from '@dcb/jssdk'
  import { globalModel } from '@/model'
  import { handleGoodsError } from '@/views/goods/exports'
  import { mapQuery, submit, Track } from '@/utils'
  import { navigateBack, redirectTo } from '@/router'
  import { wait } from 'vtils'

  import { onPageVisibilityChange } from '@/utils'

  const handleGoodsOrderError = handleGoodsError({
    商品下架: () => navigateBack(),
    活动结束: () => navigateBack(),
    活动不能参与: () => navigateBack(),
  })

  export default Vue.extend({
    mixins: [
      globalModel.mixin,
      mapQuery({
        type: {
          key: 'type',
        },
      }),
      Track.provideMark(() => ({
        page: '确认订单',
      })),
    ],

    data: () => ({
      // 页面级加载状态
      loading: true,

      // 下单数据
      orderData: {},

      goodsData: {},

      //商家备注
      remark: '',
    }),

    async mounted() {
      await this.dataInit()

      const off = onPageVisibilityChange(async visible => {
        if (visible) {
          off()
          setTimeout(() => {
            this.dataInit()
          }, 1000)
        }
      })
    },

    methods: {
      setRemark(val) {
        this.remark = val.target.value
      },

      //  初始化
      async dataInit() {
        const id = this.$route.query.id
        const data = await apiShopOpenV1OpenTradeGoodsDetail({
          id,
        })
        this.loading = false

        this.goodsData = data
      },

      // 点击立即支付按钮
      async handlePayClick() {
        await submit(async $ => {
          await $.start()
          const payData = await apiShopOpenV1OpenTradeOrderTradeOrder({
            tradeId: this.$route.query.tradeId,
            openId: globalModel.state.openid,
          }).catch(handleGoodsOrderError)
          await wait(1000)
          try {
            await dcb.requestPayment({
              provider: 'native',
              showNativeResultPage: false,
              params: {
                ...payData,
                isVirtualPay: true,
                unsupportedTips: undefined,
              },
            })
            await wait(1000)
            redirectTo('OrderPayResult')
          } catch {
            redirectTo('OrderIndex', {
              active: 1,
            })
          }
        })
      },
    },
  })
</script>

<style lang="scss" module>
  :global {
    .subsidyPopup {
      width: 270px;
      .van-dialog__message {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 18px;
        text-align: center;
        font-style: normal;
      }
    }
  }

  .station {
    margin: 12px;
  }

  .authentication {
    width: 327px;
    font-size: 13px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #666666;

    .title {
      margin-bottom: 16px;
    }

    .jumpAuthentications {
      // height: 36px;
      // width: 100%;
      padding: 8px 12px;
      background: #f5f6f8;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .leftContain {
        color: #333333;
        display: flex;
        align-items: center;
      }

      .link {
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #018ff0;
      }

      .img_icon {
        width: 16px;
        height: 16px;
        object-fit: cover;
        margin-right: 2px;
      }
    }

    .jumpAuthenticationsRow {
      padding: 8px 12px;
      background: #f5f6f8;
      border-radius: 4px;
      display: flex;
      align-items: flex-start;
      flex-direction: column;

      .leftContain {
        color: #333333;
        font-weight: 500;
        font-size: 14px;
        display: flex;
        align-items: center;
      }

      .link {
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #018ff0;
        margin-left: 18px;
      }

      .img_icon {
        width: 16px;
        height: 16px;
        object-fit: cover;
        margin-right: 2px;
      }
    }

    .tips {
      margin-top: 16px;
    }
  }

  .address {
    .add {
      display: flex;
      align-items: center;
      justify-content: center;

      .icon {
        width: 19px;
        height: 19px;
      }

      .text {
        margin-left: 2px;
        font-size: 14px;
        color: #222222;
      }

      &:active {
        opacity: 0.8;
      }
    }

    .content {
      display: flex;
      align-items: center;

      .icon {
        flex-shrink: 0;
        width: 36px;
        height: 36px;
      }

      .left {
        margin-left: 12px;
        flex-grow: 1;

        .hd {
          display: flex;
          align-items: center;

          .user {
            font-size: 14px;
            color: #222222;
            line-height: 20px;
          }

          .phone {
            margin-left: 8px;
            font-size: 14px;
            color: #888888;
            line-height: 20px;
          }

          .tag {
            margin-left: 8px;
            background: #fff2f1;
            border-radius: 1000px;
            font-size: 10px;
            color: #ff111c;
            padding: 2px 5px;
            line-height: 1;
          }
        }

        .bd {
          margin-top: 4px;
          font-size: 12px;
          color: #222222;
          line-height: 16px;
        }
      }

      .arrow {
        margin-left: 24px;
        flex-shrink: 0;
        font-size: 14px;
        color: #bebebe;
      }

      &:active {
        opacity: 0.8;
      }
    }
  }

  .merchant {
    .hd {
      display: flex;
      align-items: center;
      padding-bottom: 12px;

      .logo {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
        user-select: none;
        -webkit-touch-callout: none;
      }

      .name {
        margin-left: 6px;
        font-size: 14px;
        color: #222222;
      }
    }

    .bd {
      .goods {
        margin-top: 14px;
        display: flex;

        .cover {
          flex-shrink: 0;
          width: 85px;
          height: 85px;
          border-radius: 8px;
          overflow: hidden;
        }

        .main {
          margin-left: 12px;
          flex-grow: 1;

          .top {
            display: flex;

            .content {
              flex-grow: 1;

              .name {
                font-size: 14px;
                color: #222222;
                line-height: 20px;
              }

              .desc {
                display: inline-block;
                margin-top: 4px;
                background: #f5f6f8;
                border-radius: 1000px;
                font-size: 10px;
                color: #888888;
                padding: 3px 6px;
              }
            }

            .info {
              margin-left: 20px;
              flex-shrink: 0;

              .price {
                font-size: 12px;
                color: #1d1d1c;
                text-align: right;
              }

              .amount {
                margin-top: 5px;
                font-size: 12px;
                color: #888888;
                text-align: right;
              }
            }
          }

          .tips {
            margin-top: 4px;
            font-size: 10px;
            color: #ff111c;
            line-height: 16px;
          }
        }
      }
    }

    .ft {
      .item {
        margin-top: 12px;
        display: flex;
        align-items: center;

        .label {
          flex-shrink: 0;
          width: 85px;
          text-align: right;
          font-size: 12px;
          color: #222222;
        }

        .value {
          margin-left: 12px;
          flex-grow: 1;
          font-size: 12px;
          color: #888888;

          .input {
            width: 100%;
            appearance: none;
            outline: none;
            box-shadow: none;
            border: none;
            border-radius: 0;

            &::placeholder {
              color: #bebebe;
            }
          }
        }

        .extra {
          flex-shrink: 0;
          font-size: 12px;
          color: #222222;
        }
      }
    }

    .ex {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .count {
        font-size: 12px;
        color: #989898;
        line-height: 18px;
      }

      .label {
        font-size: 12px;
        color: #222222;
        line-height: 18px;
        margin: 0 4px;
      }

      .unit {
        font-size: 10px;
        color: #ff111c;
        line-height: 16px;
        margin-right: 2px;
      }

      .price {
        font-size: 14px;
        color: #ff111c;
        line-height: 18px;
      }
    }
  }

  .groupBuying {
    .hd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 12px;

      .title {
        display: flex;
        align-items: center;

        .icon {
          width: 16px;
          height: 16px;
        }

        .text {
          margin-left: 8px;
          font-size: 14px;
          color: #222222;
          line-height: 20px;
        }
      }

      .more {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #989898;
        line-height: 17px;

        .arrow {
          font-size: 14px;
          color: #999;
        }

        &:active {
          opacity: 0.8;
        }
      }
    }

    .bd {
      padding-top: 12px;

      .image {
        width: 100%;
      }
    }
  }

  .brief {
    .item {
      display: flex;
      align-items: center;

      + .item {
        margin-top: 12px;
      }

      .label {
        flex-shrink: 0;
        font-size: 14px;
        color: #222222;
      }

      .value {
        flex-grow: 1;
        font-size: 14px;
        color: #222222;
        text-align: right;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        line-height: 1;

        .gray {
          color: #999;
        }

        .red {
          color: #ff111c;
        }

        .arrow {
          margin-left: 4px;
          flex-shrink: 0;
          font-size: 14px;
          color: #222222;
        }
      }
    }
  }

  .actions {
    position: fixed;
    // fix: iPhone 8 下不随滑动实时更新问题
    // https://stackoverflow.com/a/49264494
    transform: translate3d(0, 0, 0);
    left: 0;
    bottom: 0;
    right: 0;
    background-color: white;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);

    .isReadBox {
      padding-left: 24px;
      padding-top: 4px;
      padding-bottom: 12px;

      .isRead {
        width: 216px;
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #666666;

        :global {
          // .van-radio__icon {
          //   display: flex;
          //   align-items: center;
          // }

          .van-checkbox__icon {
            font-size: 12px;
          }
        }
      }
    }

    .ft {
      background-color: white;
      display: flex;
      align-items: center;
      padding: 0px 12px 8px 12px;

      &:first-child {
        padding-top: 8px;
      }

      .amount {
        flex-shrink: 0;
        font-size: 14px;
        color: #888888;
      }

      .total {
        flex-shrink: 0;
        font-size: 14px;
        font-weight: bold;
        color: #ff111c;
      }

      .grow {
        flex-grow: 1;
      }

      .button {
        margin-left: 8px;
        flex-shrink: 0;
        height: 34px;
        background: linear-gradient(131deg, #ff7e43 0%, #ff111c 100%);
        border-radius: 17px;
        padding: 0 31px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #ffffff;

        &:active {
          filter: contrast(0.9);
        }

        &.secondary {
          height: 34px;
          background: #ff960a;
          border-radius: 17px;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 16px;
          font-size: 14px;
          color: #ffffff;

          + .button {
            margin-left: 0;
            height: 34px;
            background: #ff1c20;
            border-radius: 17px;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 22px;
            font-size: 14px;
            color: #ffffff;
          }
        }
      }
    }

    + .placeholder {
      height: 120px;
    }
  }

  .tipsDialog {
    &:global(.van-dialog) {
      width: 270px;
    }
  }

  .payInfoDialog {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .payInfoDialogTitle {
      margin: 20px 21px 12px 21px;
      font-size: 17px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #333333;
    }

    .payInfoDialogBody {
      // display: flex;

      text-align: center;
      margin: 0 21px 20px 21px;
      font-size: 13px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 18px;
    }

    .content {
      margin-top: 20px;
      margin-bottom: 8px;
      width: 228px;
      height: 126px;
      font-size: 13px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 18px;
    }
  }
</style>
